import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    height: { type: Number, default: 400 }
  }

  connect() {
    // TinyMCE is loaded globally by the gem
    if (typeof tinyMCE !== "undefined") {
      // Small delay to ensure DOM is ready after Turbo navigation
      setTimeout(() => this.initEditor(), 10)
    } else {
      // Wait for TinyMCE to load
      document.addEventListener("tinymce:loaded", () => this.initEditor(), { once: true })
    }
  }

  disconnect() {
    if (typeof tinyMCE !== "undefined" && tinyMCE.get(this.element.id)) {
      tinyMCE.remove(this.element)
    }
  }

  initEditor() {
    // Ensure element has an ID (required by TinyMCE)
    if (!this.element.id) {
      this.element.id = `editor-${Math.random().toString(36).substring(2, 9)}`
    }

    // Remove existing editor instance if present (handles Turbo cache restoration)
    const existingEditor = tinyMCE.get(this.element.id)
    if (existingEditor) {
      existingEditor.remove()
    }

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    tinyMCE.init({
      license_key: "gpl",
      target: this.element,
      height: this.heightValue,
      menubar: false,
      plugins: "link lists image table code fullscreen wordcount autolink",
      toolbar: "undo redo | blocks | bold italic underline strikethrough | alignleft aligncenter alignright | bullist numlist | link image table | code fullscreen",
      block_formats: "Paragraph=p; Heading 2=h2; Heading 3=h3; Heading 4=h4; Blockquote=blockquote",
      promotion: false,
      branding: false,
      relative_urls: false,
      images_upload_url: "/admin/uploads",
      automatic_uploads: true,
      images_upload_credentials: true,
      images_upload_handler: (blobInfo, progress) => {
        return new Promise((resolve, reject) => {
          const formData = new FormData()
          formData.append("file", blobInfo.blob(), blobInfo.filename())

          fetch("/admin/uploads", {
            method: "POST",
            headers: {
              "X-CSRF-Token": csrfToken
            },
            body: formData
          })
          .then(response => {
            if (!response.ok) {
              throw new Error("Upload failed")
            }
            return response.json()
          })
          .then(data => {
            resolve(data.location)
          })
          .catch(error => {
            reject(error.message)
          })
        })
      },
      content_style: `
        body {
          padding: 24px;
          max-width: 65ch;
          margin: 0 auto;
        }
      `,
      setup: (editor) => {
        editor.on("change", () => {
          editor.save()
          this.element.dispatchEvent(new Event("input", { bubbles: true }))
        })
      }
    })
  }
}
